goog.provide("shadow.js.shim.module$dayjs$locale$fr");
goog.provide("module$shadow_js_shim_module$dayjs$locale$fr");
shadow.js.shim.module$dayjs$locale$fr = shadow.js.nativeProvides["dayjs/locale/fr"] = require("dayjs/locale/fr");
module$shadow_js_shim_module$dayjs$locale$fr.default = shadow.js.shim.module$dayjs$locale$fr;
